<template>
  <header class="site-header">
    <GuNavbar
      id="heco-navigation"
      :items="navigation"
    >
      <SiteHeaderTitle />
    </GuNavbar>
  </header>
</template>

<script setup>
import GuNavbar from '@shared/gu-components/navbar/GuNavbar.vue'
import SiteHeaderTitle from './SiteHeaderTitle.vue'

import navigation from '@customers/heco/data/navigation.json'
</script>
